import React, { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Button from 'devextreme-react/button';
import Popup from './AppPopup';
import PDFViewer from '../PDFViewer';
import notify from 'devextreme/ui/notify';
import { assertPdf, DOCUMENT_PREVIEW_EVENT } from '../../services/documentService';
import '../../styles/common/DocumentPreview.scss';

export default function DocumentPreview() {
  const location = useLocation();
  const [document, setDocument] = useState(null);
  const [url, setUrl] = useState(null);
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  const [ready, setReady] = useState(false);
  const frame = useRef(null);
  const generation = useRef(0);
  const objectUrl = useRef(null);
  const queueing = useRef(false);

  const close = () => {
    generation.current += 1;
    if (objectUrl.current) URL.revokeObjectURL(objectUrl.current);
    objectUrl.current = null; setUrl(null); setDocument(null); setError('');
  };
  useEffect(() => {
    const open = async event => {
      const request = event.detail;
      if (typeof request?.load !== 'function') return;
      const token = ++generation.current;
      if (objectUrl.current) URL.revokeObjectURL(objectUrl.current);
      objectUrl.current = null; setUrl(null); setReady(false); setError(''); setDocument(request); setBusy(false);
      try {
        const pdf = await assertPdf(await request.load());
        if (generation.current !== token) return;
        objectUrl.current = URL.createObjectURL(pdf); setUrl(objectUrl.current);
      } catch (err) { if (generation.current === token) setError(err?.message || 'Unable to prepare document.'); }
    };
    window.addEventListener(DOCUMENT_PREVIEW_EVENT, open);
    return () => {
      window.removeEventListener(DOCUMENT_PREVIEW_EVENT, open); generation.current += 1;
      if (objectUrl.current) URL.revokeObjectURL(objectUrl.current);
    };
  }, []);
  useEffect(() => { close(); }, [location.key]);

  const print = () => {
    try { frame.current?.contentWindow?.focus(); frame.current?.contentWindow?.print(); }
    catch { notify('Open the PDF in a new tab to use your browser’s print controls.', 'info', 5000); }
  };
  const queue = async () => {
    if (queueing.current) return;
    queueing.current = true; setBusy(true);
    try { await document.queuePrint(); notify('Document queued for the configured printer.', 'success', 3000); }
    catch (err) { notify(err?.message || 'Unable to queue printing.', 'error', 5000); }
    finally { queueing.current = false; setBusy(false); }
  };

  return <Popup visible={!!document} title={document?.title || 'Document preview'} width="95vw" height="92dvh"
    wrapperAttr={{ class: 'document-preview-popup' }} onHiding={e => { if (busy) e.cancel = true; else close(); }}>
    <div className="document-preview">
      {error ? <p role="alert">{error}</p> : !url ? <p role="status">Preparing PDF preview…</p> :
        <PDFViewer pdfUrl={url} title={document.title} iframeRef={frame} onLoad={() => setReady(true)} />}
    </div>
  </Popup>;
}
